export default "/images/vendor/flag-icon-css/flags/1x1/pl.svg?9400273de5d060652ce7f8c43adbcf25";